// extracted by mini-css-extract-plugin
export default {"price":"E7-z","onSale":"F7-z","msrpLabelPrice":"G7-z","msrpLabel":"H7-z","originalPrice":"I7-z","percentOff":"J7-z"};